import { useGame } from '../state/useGame';
import { ALL_SKILL_IDS } from '../domain/offline/simulate';

const NAV: Array<{ id: 'skills' | 'combat' | 'inventory' | 'equipment' | 'bank' | 'parliament' | 'quests' | 'settings'; label: string }> = [
  { id: 'skills',     label: 'Skills' },
  { id: 'combat',     label: 'Combat' },
  { id: 'inventory',  label: 'Inventory' },
  { id: 'equipment',  label: 'Equipment' },
  { id: 'bank',       label: 'Bank' },
  { id: 'quests',     label: 'Quests' },
  { id: 'parliament', label: 'Parliament' },
  { id: 'settings',   label: 'Settings' },
];

export function Sidebar() {
  const page = useGame((s) => s.page);
  const setPage = useGame((s) => s.setPage);
  const skills = useGame((s) => s.state.skills);

  return (
    <nav className="sidebar" aria-label="Primary">
      <h1>Herman Idle</h1>
      {NAV.map((n) => {
        const lvl =
          n.id === 'skills' ? Math.max(...ALL_SKILL_IDS.map((id) => skills[id]?.level ?? 1)) : null;
        return (
          <button
            key={n.id}
            className={`nav-btn ${page === n.id ? 'active' : ''}`}
            onClick={() => setPage(n.id)}
            aria-current={page === n.id ? 'page' : undefined}
            data-page-id={n.id}
          >
            <span>{n.label}</span>
            {lvl !== null && <span className="lvl">Lv {lvl}</span>}
          </button>
        );
      })}
    </nav>
  );
}